import React, { FC, useEffect, useState } from 'react';
import getConfig from 'next/config';
import ReactGA from 'react-ga';
import AppMobile from '../components_mobile/App/App';
import AppDesktop from '../components_desktop/AppDesktop';
import TrackingScripts from '../components_common/TrackingScripts';
import FullHeightFlex from '../components_common/FullHeightFlex';
import centeredFlexColumnStyle from './centeredFlexColumnStyle';
import ReactPixel from '../helpers/pixels/fbPixel';
import { HeadWrapper } from '../components/HeadWrapper/HeadWrapper';
import { Klaviyo } from '../components/Klaviyo/Klaviyo';
import { useAppContext } from '../store/appContext';
import { Mobile, Desktop } from '../components/MediaQuery/index';
import { PageSpecificMetadataProps } from '../components/PageSpecificMetadata/PageSpecificMetadata';
import { cartItemsContext } from '../store/cartItemsContext';
import { useCartItems } from '../hooks/useCartItems';

interface AppWrapperProps {
  currPage?: string;
  desktopComp: React.ReactElement;
  metadata?: PageSpecificMetadataProps['metadata'];
  mobileComp: React.ReactElement;
}
const AppWrapper: FC<AppWrapperProps> = props => {
  const { currPage, desktopComp, mobileComp, metadata } = props;
  const { email, userId, fbOptions, numCartItems } = useAppContext();
  const [trackingInitialized, setTrackingInitialized] = useState(false);
  const cartItems = useCartItems(numCartItems);

  const {
    serverRuntimeConfig: { isServer },
  } = getConfig();

  useEffect(() => {
    if (trackingInitialized) return;

    ReactGA.initialize('UA-11398566-5', { debug: false });
    ReactGA.set({ '&uid': userId });
    ReactGA.pageview(window.location.pathname);
    const { debug } = fbOptions;
    ReactPixel.init({ em: email }, debug);

    setTrackingInitialized(true);
  }, [email, fbOptions, trackingInitialized, userId]);

  return (
    <cartItemsContext.Provider value={cartItems}>
      <>
        {isServer && <HeadWrapper metadata={metadata} />}
        <Klaviyo />
        <FullHeightFlex id="root">
          <Mobile>
            <AppMobile currPage={currPage}>{mobileComp}</AppMobile>
          </Mobile>
          <Desktop>
            <AppDesktop currPage={currPage} style={centeredFlexColumnStyle}>
              {desktopComp}
            </AppDesktop>
          </Desktop>
        </FullHeightFlex>
        <TrackingScripts />
      </>
    </cartItemsContext.Provider>
  );
};

export default AppWrapper;
